import React, { Fragment } from 'react'

import Link from 'gatsby-link'
import cn from 'classnames'
import LoginATI from "../components/Auth/Login";
import { scrollToContent } from '../helpers'
import 'swiper/dist/css/swiper.min.css'
import './index.styl'

import heroVideo from './hero-video.mp4'
import img01 from '../images/home__who-we-are.jpg'
import img02 from '../images/home__talk-to-us.jpg'
import img03 from '../images/home__our-tech.jpg'
import img04 from '../images/home__careers.jpg'
import ContactForm from "../components/Forms/ContactForm"
import contactFormImg from '../images/home__contact-form.jpg'
import NewsSwiper from '../components/News/NewsSwiper';
//import '../components/Auth/atiLogin'

const Page = () => (
  <Fragment>
    <header
      className={cn('c-header', 'c-header--full', 't-context--dark', 'bg')}
    >
      <video
        className="c-header__video"
        src={heroVideo}
        autoPlay
        playsInline
        loop
        muted
      />
      <div className="c-header__content c-header__content--index o-container t-center">
        <h1 className="t-hero" style={{ maxWidth: '18em' }}>
          North America’s leading travel service provider
        </h1>
        <p className="t-hero-subheading mt20 min-tabletMd">
          ATI takes the concept of destination management to a whole new level
        </p>
        <a
          href="#content"
          className="c-btn t-link mt30"
          onClick={scrollToContent}
        >
          Learn More
        </a>
        <svg
          viewBox="0 0 24 24"
          className="c-header__arrow"
          style={{ bottom: 10 }}
          onClick={scrollToContent}
        >
          <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
        </svg>
      </div>
      <LoginATI name="atiLogin" source="index" />
    </header>
    <main id="content">
      <section className="tiles t-context--dark">
        <Link to="/who-we-are" className="tile">
          <div
            className="tile__img"
            style={{ backgroundImage: `url(${img01})` }}
          />
          <div className="tile__content">
            <h3 className="tile__title">Who We Are ></h3>
            <p className="tile__desc">
              From the beginning, ATI’s philosophy has been “innovation, not
              duplication”...
            </p>
          </div>
        </Link>
        <Link to="/what-we-offer" className="tile">
          <div
            className="tile__img"
            style={{ backgroundImage: `url(${img02})` }}
          />
          <div className="tile__content">
            <h3 className="tile__title">What We Offer ></h3>
            <p className="tile__desc">
              ATI’s product range and service expertise is unparalleled…
            </p>
          </div>
        </Link>
        <Link to="/our-technology" className="tile">
          <div
            className="tile__img"
            style={{ backgroundImage: `url(${img03})` }}
          />
          <div className="tile__content">
            <h3 className="tile__title">Our Technology ></h3>
            <p className="tile__desc">
              Our proprietary technology is focused on our partners’ success…
            </p>
          </div>
        </Link>
        <Link to="/careers" className="tile">
          <div
            className="tile__img"
            style={{ backgroundImage: `url(${img04})` }}
          />
          <div className="tile__content">
            <h3 className="tile__title">Careers ></h3>
            <p className="tile__desc">
              Join the ATI Team…
            </p>
          </div>
        </Link>
      </section>
      <NewsSwiper source="index" maxSwipesCount="16" />
      <section
        className="contact-form-section o-section--large t-context--dark"
        style={{ backgroundImage: `url(${contactFormImg})` }}
      >
        <ContactForm source="index" />
      </section>

    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/index.js